export default "__VITE_ASSET__DsFg6Isy__"